import { useQuery } from "@tanstack/react-query";
import { Facebook, Instagram } from "lucide-react";
import { api } from "@/lib/api";

const withProto = (u) => (u && !/^https?:\/\//i.test(u) ? `https://${u}` : u);

// variant: "footer" (light on dark) | "contact" (gold pills on light)
export function SocialLinks({ variant = "footer", className = "" }) {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
  const social = settings?.social || {};
  const items = [
    { key: "facebook", url: withProto(social.facebook), Icon: Facebook, label: "Facebook" },
    { key: "instagram", url: withProto(social.instagram), Icon: Instagram, label: "Instagram" },
  ].filter((i) => i.url);

  if (items.length === 0) return null;

  const cls = variant === "contact"
    ? "w-11 h-11 rounded-full bg-[#E8E6E1] hover:bg-[#BE923C] text-[#BE923C] hover:text-white flex items-center justify-center transition-colors"
    : "w-10 h-10 rounded-full bg-white/10 hover:bg-[#BE923C] text-white/80 hover:text-white flex items-center justify-center transition-colors";

  return (
    <div data-testid="social-links" className={`flex items-center gap-3 ${className}`}>
      {items.map(({ key, url, Icon, label }) => (
        <a key={key} href={url} target="_blank" rel="noreferrer" aria-label={label}
          data-testid={`social-${key}`} className={cls}>
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
}
